import { coinFlipAnimationNames, CoinFlipMarketType } from '../coinFlipCore/constants';
import { coinFlipBetsStore } from '../coinFlipStore/betStore';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { CoinFlipSoundsName } from '../coinFlipCore/constants/sounds';

class CoinFlipDrawerService {
  setCoinSpine(coinSpine) {
    this.coinSpine = coinSpine;
  }

  setRingSpine(ringSpine) {
    this.ringSpine = ringSpine;
  }

  setBgSpine(bgSpine) {
    this.bgSpine = bgSpine;
  }

  playBackGroundAnimation() {
    this.bgSpine.play('animation', true);
  }

  playCoinIdle() {
    const { cashOutWin, lastStepResult } = coinFlipBetsStore;
    if (cashOutWin) {
      this.handleWinCoin(lastStepResult, true);
    } else {
      this.coinSpine.play(coinFlipAnimationNames.idle, true);
    }
  }

  handleWinCoin(marketType, isWin) {
    const { lastStepResult, setLastStepResult } = coinFlipBetsStore;
    if (lastStepResult === null) {
      if (CoinFlipMarketType.Heads === marketType) {
        this.playGoldToGold(isWin);
      } else {
        this.playSilverToSilver(isWin);
      }
    } else if (CoinFlipMarketType.Heads === lastStepResult) {
      if (lastStepResult === marketType) {
        this.playGoldToGold(isWin);
      } else {
        this.playGoldToSilver(isWin);
      }
    } else if (lastStepResult === marketType) {
      this.playSilverToSilver(isWin);
    } else {
      this.playSilverToGold(isWin);
    }
    setTimeout(
      () => {
        if (isWin) {
          soundService.play(CoinFlipSoundsName.rightDecision);
        } else {
          soundService.play(CoinFlipSoundsName.lose);
        }
      },
      userSettingsStore.isTurboOn ? 450 : 800
    );
    setLastStepResult(marketType);
  }

  playGoldToGold(isWin) {
    this.coinSpine.play(
      coinFlipAnimationNames.goldGold,
      false,
      userSettingsStore.isTurboOn ? (userSettingsStore.isTurboOn ? 1.5 : 1) : 1
    );
    this.handleRingWinLose(this.coinSpine, coinFlipAnimationNames.goldGold, isWin, true);
  }

  playGoldToSilver(isWin) {
    this.coinSpine.play(
      coinFlipAnimationNames.goldSilver,
      false,
      userSettingsStore.isTurboOn ? 1.5 : 1
    );
    this.handleRingWinLose(this.coinSpine, coinFlipAnimationNames.goldSilver, isWin);
  }

  playSilverToGold(isWin) {
    this.coinSpine.play(
      coinFlipAnimationNames.silverGold,
      false,
      userSettingsStore.isTurboOn ? 1.5 : 1
    );
    this.handleRingWinLose(this.coinSpine, coinFlipAnimationNames.silverGold, isWin, true);
  }

  playSilverToSilver(isWin) {
    this.coinSpine.play(
      coinFlipAnimationNames.silverSilver,
      false,
      userSettingsStore.isTurboOn ? 1.5 : 1
    );
    this.handleRingWinLose(this.coinSpine, coinFlipAnimationNames.silverSilver, isWin);
  }

  playRingGoldWin() {
    this.ringSpine.play(
      coinFlipAnimationNames.winGold,
      false,
      userSettingsStore.isTurboOn ? 1.5 : 1
    );
  }

  playRingGoldLose() {
    this.ringSpine.play(
      coinFlipAnimationNames.looseGold,
      false,
      userSettingsStore.isTurboOn ? 1.5 : 1
    );
  }

  playRingSilverWin() {
    this.ringSpine.play(
      coinFlipAnimationNames.winSilver,
      false,
      userSettingsStore.isTurboOn ? 1.5 : 1
    );
  }

  playRingSilverLose() {
    this.ringSpine.play(
      coinFlipAnimationNames.looseSilver,
      false,
      userSettingsStore.isTurboOn ? 1.5 : 1
    );
  }

  handleRingWinLose(spine, animName, isWin, isGold) {
    this.ringSpine.state.clearTracks();
    setTimeout(() => {
      if (isGold) {
        if (isWin) {
          this.playRingGoldWin();
        } else {
          this.playRingGoldLose();
        }
      } else if (isWin) {
        this.playRingSilverWin();
      } else {
        this.playRingSilverLose();
      }
    }, 200);
  }
}

export const coinFlipDrawerService = new CoinFlipDrawerService();
